import { MissionSection } from "components/missionDetail/MissionDetailParts";
import { languageIcon, licenceIcon, toolIcon } from "components/missionDetail/missionDetailIcons";

/** Requirement families and the icon of each item, in the app order. */
const FAMILIES = [
    { key: "tools", iconOf: toolIcon },
    { key: "licences", iconOf: licenceIcon },
    { key: "language", iconOf: languageIcon },
];

/**
 * The job requirements by family (equipment / PPE, licences, languages), as in the temp worker
 * app (MissionRequirements): a title, "Requis pour cette mission", then one line per item with
 * its icon.
 */
const MissionRequirements = ({ mission, labels }) => {
    const families = FAMILIES.filter((family) => mission?.[family.key]?.length);
    if (!families.length) return null;

    return (
        <MissionSection>
            <div className="flex flex-col gap-6">
                {families.map(({ key, iconOf }) => (
                    <div key={key}>
                        <h2 className="text-sm font-semibold leading-5 text-gray-900">{labels[key]}</h2>
                        <p className="text-sm leading-5 text-gray-500">{labels.required}</p>
                        <ul className="mt-3 flex flex-col gap-3">
                            {mission[key].map((item, index) => {
                                const Icon = iconOf(item);
                                return (
                                    <li key={`${item}-${index}`} className="flex min-h-[26px] items-center gap-3">
                                        <Icon size={20} color="#1f2937" strokeWidth={2} aria-hidden="true" />
                                        <span className="flex-1 text-sm leading-5 text-gray-900">{item}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </div>
        </MissionSection>
    );
};

export default MissionRequirements;
